/* eslint-disable */
// Disabling es-lint to prevent bad formatting within map (it removes the tabs / spaces) on line 38
// Can't use disable next line as renders comments on frontend

import { ThemeComponent } from "@/theme/ThemeComponent";
import { html, render } from "lit-html";
import { cart } from "@/theme/Cart";
import { CartItem, Component, Ref } from '@eastsideco/salvo-ts';
import { QuantitySpinner } from "../QuantitySpinner/QuantitySpinner";
import { formatPrice } from "@/utils/products";

@Component
export class CartItemRow extends ThemeComponent {
    private quantity: QuantitySpinner;
    private discount: string = '';
    private url: string = '';

    constructor(item: CartItem, quantity: QuantitySpinner, strings: string, hasSubscription: boolean) {
        super();
        this.quantity = quantity;
        this.url = item.url;
        
        if (hasSubscription && item.url.includes('-1')) {
            this.discount = `${item.properties.discountPercentage}`;
            this.url = item.url.replace('-1', '');
        }
        this.render(item, quantity, strings, hasSubscription, this.discount);
    }

    render(item: CartItem, quantity: QuantitySpinner, strings: string, hasSubscription: boolean, discount: string) {
        render(html`
            <div class="cart-row">
                <div class="cart-row__item">
                    <a href="${this.url}" class="cart-row__image object-cover">
                        <img src="${item.image}" alt="${item.productTitle}">
                    </a>
                    <div class="cart-row__details">
                        <div class="cart-row__details-header">
                            <h3 class="cart-row__details-title">${item.productTitle}</h3>

                            <p class="cart-row__details-price">
                                ${ formatPrice(item.linePrice, String(JSON.parse(strings).moneyFormat))}
                            </p>
                        </div>

                        ${item.optionsWithValues.map((option) => (
                            option.value.toLowerCase() != 'default title' ?
                                html`<p class="cart-row__details-options">${option.name}: ${option.value}</p>`
                            :
                                html`<p class="cart-row__details-options"></p>`
                               
                            ))}
                        
                    </div>
                    
                    <div class="cart-row__actions">
                        ${!hasSubscription ?
                            html`
                                <p class="cart-row__quantity" data-id="${item.id}">
                                    ${quantity}
                                </p>
                            `
                        :
                            html`
                                <div class="cart-row__subscription">
                                    <p class="cart-row__subscription-subtitle">Delivery options</p>

                                    <p class="cart-row__subscription-title">
                                        Delivery every
                                        ${item.properties.shipping_interval_frequency}
                                        ${item.properties.shipping_interval_unit_type}
                                    </p>

                                    ${discount && discount !== 'undefined' ?
                                        html`<p class="cart-row__subscription-discount">
                                            Save ${discount}
                                        </p>`
                                    :
                                        null
                                    }
                                </div>
                            `
                        }
    
                        <button 
                            class="cart-row__remove" 
                            data-ref="removeItem" 
                            data-item="${item.variantId}"
                        >
                            ${JSON.parse(strings).remove}

                            <svg
                                width="12"
                                height="12"
                                viewBox="0 0 23 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="
                                        M23 1.244 21.756 0l-9.427 9.429a1.173
                                        1.173 0 0 1-1.659 0L1.243 0 0 1.244l9.423
                                        9.428a1.173 1.173 0 0 1 0 1.659L0 21.757l1.244
                                        1.245 9.426-9.428a1.172 1.172
                                        0 0 1 1.659 0l9.427 9.428L23 21.757l-9.428-9.426a1.173
                                        1.173 0 0 1 0-1.659L23 1.244Z
                                    "
                                    fill="#231F20"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        `, this);
    }

    @Ref() removeItem!: HTMLButtonElement;

    /**
     * Initialise.
     */
    init() {
        this.$listen(this.removeItem, 'click', () => this.handleRemoveItem(this.removeItem));
        this.$subscribe(this.quantity.onChange, (value) => this.handleQuantity());
    }

    /**
     * Remove item from cart.
     * @param target - remove button.
     */
    handleRemoveItem(target: HTMLElement) {
        if (target.dataset.item === undefined) { return; }

        for (const item of cart.items) {
            if (~~item.id === ~~target.dataset.item) {
                try {
                    cart.removeItem(item).catch((event: unknown) => {
                        if (event instanceof Error) {
                            this.$log.error(event.message);
                        }
                    });

                } catch (event: unknown) {
                    if (event instanceof Error) {
                        this.$log.info('Remove error', event.message);
                    }
                }
            }
        }
    }

    /**
     * Handle cart quanitty Change.
     */
    handleQuantity() {
        if(this.quantity === null || this.quantity.parentNode === null ) { return; }

        if (this.quantity.parentNode instanceof HTMLElement) {
            if(this.quantity.parentNode.dataset.id == null) { return; }
            const itemId = this.quantity.parentNode.dataset.id;

            for (const item of cart.items) {
                if (+item.id === +itemId) {
                    const quantity = +this.quantity.input.value;

                    try {
                        cart.changeItem(item, quantity, null).catch((event: unknown) => {
                            if (event instanceof Error) {
                                this.$log.error(event.message);
                            }
                        });

                    } catch (event: unknown) {
                        const { message } = event as Error;
                        this.$log.info('Quantity error', message);
                    }
                }
            }
        }
    }
}

